module.exports = __webpack_public_path__ + "resources/img/solution_game_infra_m.dd868340950db57fc49c4d682952c294.png";